import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Outlet, ScrollRestoration } from "react-router-dom";
import useWidth from "../hooks/useWidth";
import MobileNavigation from "./MobileNavigation";

export default () => {
  const width = useWidth();

  return (
    <>
      {/* <Navbar/> */}
      <section className="">
        <Outlet />
        <ScrollRestoration/>
      </section>
      <Footer/>
     {width < 992 && <MobileNavigation/>}
    </>
  );
};
